<div bsModal
     #changeNotificationEmailModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="changeNotificationEmailModal"
     aria-hidden="true" [config]="{backdrop: 'static', keyboard: false}">

    <div class="modal-dialog modal-lg search-customer-modal">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ "ChangeEmail" | localize }}
                </h5>
                <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <form #changeNotificationEmailForm="ngForm"
                  role="form"
                  novalidate
                  class="form-validation"
                  *ngIf="active"
                  (submit)="changeEmail()">

                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-12 col-lg-12">
                            <label for="NotificationEmail">
                                {{"NotificationEmail" | localize}} *
                            </label>
                            <input id="NotificationEmail"
                                   #notificationEmailInput="ngModel"
                                   type="email"
                                   name="notificationEmail"
                                   class="form-control"
                                   [ngClass]="{'edited':notificationEmail}"
                                   [(ngModel)]="notificationEmail"
                                   required
                                   email
                                   maxlength="64">

                            <validation-messages  [formCtrl]="notificationEmailInput"></validation-messages>
                        </div>

                        <div class="form-group col-12 col-lg-12">
                            <p>{{ "Axilla.Webshop.FieldAgent.NotificationEmail.Text" | localize}}</p>
                        </div>

                        <div class="form-group col-12 col-lg-12" *ngIf="'Pages.App.Webshop.Customer.ChangeDirectly' | permission">
                            <div class="kt-checkbox-list">
                                <label class="kt-checkbox">
                                    <input id="isPermanent" type="checkbox" name="IsDefault" [(ngModel)]="isPermanent">
                                    {{"Axilla.Webshop.FieldAgent.NotificationEmail.PermanentMessage" | localize}}
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            [disabled]="saving"
                            class="btn btn-secondary"
                            (click)="close()">
                        <span translation="Cancel" source=""></span>
                    </button>
                    <button type="submit"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')"
                            class="btn btn-primary"
                            [disabled]="!changeNotificationEmailForm.form.valid
                                        || saving ">
                        <i class="fa fa-save"></i>
                        <span translation="Save" source=""></span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
